import React from 'react';
import { withAuth, WithAuthProps } from 'components/header/hoc/with-auth';
import { HeaderModelData } from 'types/model';
import { useStoreon } from 'storeon/react';
import { State } from 'store/types';
import { getIsB2BEnabled, isUserAuth } from 'selectors';
import { useAuthLogic } from 'components/header/hooks/auth';
import { B2B_PERSONAL_ACCOUNT_HOST } from 'common/constants/header-constants';
import { SignIn, User } from './components';
import { useLoyaltyData } from 'common/hooks/use-loyalty-data';
import { UserWithLoyalty } from './components/user/user-with-loyalty/user-with-loyalty';

export interface WithLoginB2B {
  loginB2B: () => void;
}

export interface ProfileBaseProps extends WithAuthProps, WithLoginB2B {
  model: HeaderModelData;
}

export const ProfileBase = (props: ProfileBaseProps) => {
  const { model, ...authProps } = props;
  const { login, loginB2B } = authProps;
  const loginPageUrl = model.header.initUrl;
  const { cookies } = useStoreon<State>('cookies');
  const isAuth = isUserAuth(cookies);
  const isB2BEnabled = getIsB2BEnabled(model.experiments);
  const {
    fetchedLoyaltyAccountSuccess,
    loyaltyAccountIdentifier,
    points,
    rankLabel,
    keycardPro,
    fetchLoyaltyRankLoading,
    fetchLoyaltyPointsLoading,
    fetchLoyaltyPointsError,
    fetchLoyaltyRankError,
  } = useLoyaltyData();
  const errorByKeycardType = keycardPro
    ? fetchLoyaltyPointsError || fetchLoyaltyRankError
    : fetchLoyaltyPointsError;
  const profileWithLoyalty = fetchedLoyaltyAccountSuccess && loyaltyAccountIdentifier && !errorByKeycardType;

  if (isAuth) {
    return profileWithLoyalty ? (
      <UserWithLoyalty
        model={model}
        points={points}
        pointsLoading={fetchLoyaltyPointsLoading}
        rankLabel={rankLabel}
        rankLoading={fetchLoyaltyRankLoading}
        proCard={!!keycardPro}
        {...authProps}
      />
    ) : (
      <User profileWithLoyalty={false} model={model} {...authProps} />
    );
  }

  return (
    <SignIn
      b2bLoginPageUrl={B2B_PERSONAL_ACCOUNT_HOST}
      login={login}
      loginPageUrl={loginPageUrl}
      loginB2B={loginB2B}
      isB2BEnabled={isB2BEnabled}
    />
  );
};

export const Profile = withAuth<ProfileBaseProps, WithAuthProps & WithLoginB2B>(ProfileBase, useAuthLogic);
